export interface ParamData {
  user: string;
  entity: string;
  startingFrom: string;
  endingOn: string;
}

export const initialParamData: ParamData = {
  user: "",
  entity: "",
  startingFrom: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000) // 7 days ago
    .toISOString()
    .split("T")[0],
  endingOn: new Date().toISOString().split("T")[0], // today
};
